import {
    GET_LifestyleMembership,
    ADD_LifestyleMembership,
    TOGGLE_LifestyleMembership,
    RESET_LifestyleMembership,
    UPDATE_LifestyleMembership
  } from "../actionTypes";

const lifestyleMembershipReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LifestyleMembership:
      return action.payload;

    case ADD_LifestyleMembership:
      return action.payload;

    case UPDATE_LifestyleMembership:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_LifestyleMembership:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_LifestyleMembership:
      return null;

    default:
      return state;
  }
};

export default lifestyleMembershipReducer;
